export default "__VITE_ASSET__CrAJ$1hx__"